module.exports = __webpack_public_path__ + "static/media/new-logo.78a8c557.png";